export const fakeRecurrences = [
  '__b',
  // 'Wz9zMAalert_600', // melver certifica
  // '9AXPzXpDBA', // melver certifica
  // 'rfXh0T0Xd5', // melver certifica
  // 'rSlLTPwUsb', // melver certifica
  // 'DR86o1Dnkb', // melver certifica
  // 'GuRDvUU1FS', // melver certifica
  // '4xmvx0Hq2s', // melver certifica
  // 'fTCwhJZlJk', // melver pro
];
